import styled from 'styled-components'
import { themeGet } from 'styled-system'
import theme from 'styles/theme'
import Link from 'components/Link'

const iconCheck = {
  default: `"data:image/svg+xml,%3Csvg version='1.1' id='Layer_1' xmlns='http://www.w3.org/2000/svg' x='0px' y='0px' viewBox='0 0 16 16'%3E%3Cpolygon points='6.1,12.2 2.8,8.9 3.5,8.1 6.1,10.8 12.8,4.1 13.5,4.9' fill='%237E8A4A' /%3E%3C/svg%3E"`,
  disabled: `"data:image/svg+xml,%3Csvg version='1.1' id='Layer_1' xmlns='http://www.w3.org/2000/svg' x='0px' y='0px' viewBox='0 0 16 16'%3E%3Cpolygon points='6.1,12.2 2.8,8.9 3.5,8.1 6.1,10.8 12.8,4.1 13.5,4.9' fill='%23F0F0F0' /%3E%3C/svg%3E"`,
  warning: `"data:image/svg+xml,%3Csvg version='1.1' id='Layer_1' xmlns='http://www.w3.org/2000/svg' x='0px' y='0px' viewBox='0 0 16 16'%3E%3Cpolygon points='6.1,12.2 2.8,8.9 3.5,8.1 6.1,10.8 12.8,4.1 13.5,4.9' fill='%23E2635D' /%3E%3C/svg%3E"`,
}

export const StyledLink = styled(Link)`
  margin-left: ${`calc(30px + ${theme.space[4]})`};
  color: ${themeGet('colors.sagemedium')};
  border-bottom: 1px solid ${themeGet('colors.alabaster')};
  transition: border-color 0.2s ease-in-out;

  &:hover {
    border-color: ${themeGet('colors.sagemedium')};
  }
`

export const Input = styled.input.attrs((props) => ({
  type: 'checkbox',
  disabled: props.isDisabled,
}))``

export const LabelText = styled.div`
  align-items: center;
  color: ${theme.colors.sagedark};
  display: flex;
  flex-direction: row;
  position: relative;
  margin-right: 10px;

  &::before,
  &::after {
    content: '';
    display: block;
  }

  &::before {
    background: ${(props) =>
      !props.hasError
        ? props.theme.colors.sagelightToSandstone
        : theme.colors.redlight};
    border: 1px solid transparent;
    border-color: ${(props) =>
      !props.hasError
        ? props.theme.colors.sagelightToGreen
        : themeGet('colors.red')};
    flex: none;
    height: 30px;
    margin-right: ${theme.space[4]};
    width: 30px;
  }

  &::after {
    background-color: transparent;
    background-image: ${(props) =>
      !props.hasError
        ? `url(${iconCheck.default})`
        : `url(${iconCheck.warning})`};
    background-position: 0;
    background-repeat: no-repeat, repeat;
    background-size: 100%;
    height: 16px;
    left: 7px;
    position: absolute;
    transform: scale(0);
    transition: transform 0.1s ease-out;
    width: 16px;
    z-index: 10;
  }
`

export const InputCheckbox = styled.div`
  input[type='checkbox'] {
    display: none;

    &:checked + ${LabelText}:after {
      transform: scale(1);
    }
  }
`
